import React, { useEffect, useState } from "react";
import { useForm, useFieldArray } from "react-hook-form";
import Input from "../../Common/Input/Input";
import Button from "../../Common/Button/Button";
import classes from "./ScoreBandConfig.module.scss";
import PlusIcon from "../../Common/SvgIcons/CommonIcons/PlusIcon";
import DeleteIcon from "../../Common/SvgIcons/TableIcons/DeleteIcon";

function ScoreBandConfig({
  errors,
  control,
  trigger,
  formValues,
  shotclassType,
}) {
  const { fields, append, remove } = useFieldArray({
    control,
    name: "scoreBands",
  });
  // debugger
  const handleAddRow = () => {
    append({
      minScore: "",
      maxScore: "",
      feedbackMessage: "",
    });
  };

  const handleDeleteRow = (index) => {
    if (!formValues?.Other?.IsDistributed) remove(index);
  };

  return (
    <div className={classes.scoreBandConfig}>
      <div className={classes.scoreBandConfig__header}>
        <h2 className={classes.scoreBandConfig__title}>
          Score Band Configuration (Optional)
        </h2>
        <p className={classes.scoreBandConfig__helpText}>
          Create sequential score ranges (e.g., 0-10, 11-20, 21-30) to provide different feedback messages based on user scores.
        </p>
      </div>

      <div className={classes.scoreBandConfig__container}>
        <div className={classes.scoreBandConfig__headers}>
          <div className={classes.scoreBandConfig__headers__scoreRange}>
            Min Score
          </div>
          <div className={classes.scoreBandConfig__headers__scoreRange}>
            Max Score
          </div>
          <div className={classes.scoreBandConfig__headers__feedbackMessage}>
            Feedback Message (Max : 500 Characters)
          </div>
          <div className={classes.scoreBandConfig__headers__actions}>
            {/* Empty space for delete button alignment */}
          </div>
        </div>

        <div className={classes.scoreBandConfig__rows}>
          {fields.map((field, index) => (
            <div key={field.id} className={classes.scoreBandConfig__row}>
              <div className={classes.scoreBandConfig__row__scoreRange}>
                <Input
                  name={`scoreBands.${index}.minScore`}
                  labelColor="light"
                  placeholder="0 - 100"
                  width={10}
                  error={errors?.scoreBands?.[index]?.minScore?.message}
                  errorPosition="absolute"
                  onChange={() => {
                    trigger([`scoreBands.${index}.minScore`, "scoreBands"]);
                  }}
                  disabled={formValues?.Other?.IsDistributed}
                />
              </div>
              <div className={classes.scoreBandConfig__row__scoreRange}>
                <Input
                  name={`scoreBands.${index}.maxScore`}
                  labelColor="light"
                  placeholder="0 - 100"
                  width={10}
                  errorPosition="absolute"
                  error={errors?.scoreBands?.[index]?.maxScore?.message}
                  onChange={() => {
                    trigger([`scoreBands.${index}.maxScore`, "scoreBands"]);
                  }}
                  disabled={formValues?.Other?.IsDistributed}
                />
              </div>

              <div className={classes.scoreBandConfig__row__feedbackMessage}>
                <Input
                  name={`scoreBands.${index}.feedbackMessage`}
                  labelColor="light"
                  placeholder="Enter feedback message"
                  width={68}
                  maxLength={500}
                  errorPosition="absolute"
                  error={errors?.scoreBands?.[index]?.feedbackMessage?.message}
                  onChange={() => {
                    trigger([
                      `scoreBands.${index}.feedbackMessage`,
                      "scoreBands",
                    ]);
                  }}
                />
              </div>
              {!formValues?.Other?.IsDistributed && (
                <div
                  className={classes.scoreBandConfig__row__actions}
                  onClick={() => handleDeleteRow(index)}
                >
                  <DeleteIcon />
                </div>
              )}

            </div>
          ))}
        </div>

        {/* Display global score bands error */}
        {errors?.scoreBands?.message && (
          <div className={classes.scoreBandConfig__globalError}>
            {errors.scoreBands.message}
          </div>
        )}

        <div className={classes.scoreBandConfig__addRow}>
          <Button
            label={"Add Score Band"}
            height="3"
            width="17.9"
            icon={PlusIcon}
            onClick={handleAddRow}
            light
            type="button"
            disabled={fields?.length >= 10 || formValues?.Other?.IsDistributed}
          />
        </div>
      </div>
    </div>
  );
}

export default ScoreBandConfig;
